module.exports = "/images/vendor/flag-icon-css/flags/4x3/ve.svg?b2cd5a9a011fd43f115a2c5e2c9f91e5";